/**
 * Pared de videos.
 *
 * Solo reproduce el clip que esta a la vista, y lo para al salir. Los videos se
 * sirven con preload="none", asi que nada se descarga hasta que hace falta: en
 * una conexion movil floja, cuatro clips cargando a la vez arruinan la pagina.
 *
 * Quien pide reducir el movimiento en su dispositivo no ve nada moverse solo.
 */
class WuffyVideoWall extends HTMLElement {
  /** @type {IntersectionObserver | null} */
  #observer = null;

  connectedCallback() {
    const clips = this.querySelectorAll('video[data-wuffy-clip]');
    if (!clips.length) return;

    // Los clips se sirven sin controles porque se reproducen solos. Si alguien
    // pide reducir el movimiento no van a arrancar, asi que sin controles se
    // quedaria mirando una foto fija: se los devolvemos.
    const quieto = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    if (quieto?.matches) {
      clips.forEach((clip) => {
        if (clip instanceof HTMLVideoElement) clip.controls = true;
      });
      return;
    }

    if (typeof IntersectionObserver !== 'function') {
      clips.forEach((clip) => {
        if (clip instanceof HTMLVideoElement) clip.controls = true;
      });
      return;
    }

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const video = entry.target;
          if (!(video instanceof HTMLVideoElement)) continue;

          if (entry.isIntersecting) {
            // Sin muted el navegador rechaza el play automatico, y con razon.
            video.muted = true;
            const started = video.play();
            if (started && typeof started.catch === 'function') started.catch(() => {});
          } else if (!video.paused) {
            video.pause();
          }
        }
      },
      { threshold: 0.5 }
    );

    clips.forEach((clip) => this.#observer?.observe(clip));
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }
}

if (!customElements.get('wuffy-video-wall')) {
  customElements.define('wuffy-video-wall', WuffyVideoWall);
}
